import Dashboard from "views/Dashboard.js";
import OutstandingQuotes from "views/OutstandingQuotes.js";
import JobListWrapper from "views/JobListWrapper.js";
import SiteSearch from "views/SiteSearch/SiteSearch.js"; // Adjust the path as necessary
import LoginPage from "views/Pages/LoginPage.js";
import UserPage from "views/Pages/UserPage.js";
import FileStore from "views/FileStore.js";
 
// ADDED A hidden tag to the LoginPage route to hide it from the sidebar. Do this with any pages requied that should
 
var dashRoutes = [
  {
    path: "/dashboard",
    name: "Home",
    icon: "business_chart-pie-36",
    component: <Dashboard />,
    layout: "/admin",
  },
  {
    path: "/sitesearch", // The :filter indicates a URL parameter named 'filter'
    name: "Site Search",
    icon: "ui-1_zoom-bold",
    component: <SiteSearch />,
    layout: "/admin",
  },
  {
    path: "/outstandingquotes",
    name: "Outstanding Quotes",
    icon: "ui-1_zoom-bold",
    component: <OutstandingQuotes />,
    layout: "/admin",
  },
  {
    path: "/joblist/:filter", // The :filter indicates a URL parameter named 'filter'
    name: "Job List",
    icon: "ui-1_zoom-bold",
    component: <JobListWrapper />,
    layout: "/admin",
    hidden: true
  },
  {
    path: "/login-page",
    name: "Login Page",
    short: "Login",
    mini: "LP",
    component: <LoginPage />,
    layout: "/auth",
    hidden: true
  },
  {
    path: "/user-page",
    name: "User Profile",
    mini: "UP",
    component: <UserPage />,
    layout: "/admin",
    hidden: true
  },
  {
    path: "/file-store",
    name: "Filestore",
    icon: "arrows-1_cloud-download-93",
    mini: "FS",
    component: <FileStore />,
    layout: "/admin"
  },
];


export default dashRoutes;